import { useState, useMemo } from "react";

const usePagination = (dataSource, pageSize) => {
  const [currentPage, setCurrentPage] = useState(1);

  const paginationData = useMemo(() => {
    const totalItems = dataSource?.length || 0;
    const totalPages = Math.ceil(totalItems / pageSize);
    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = dataSource?.slice(indexOfFirstItem, indexOfLastItem) || [];

    return {
      totalItems,
      totalPages,
      currentItems,
      currentPage,
    };
  }, [dataSource, pageSize, currentPage]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return {
    ...paginationData,
    handlePageChange,
  };
};

export default usePagination;

